
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    highlightIndex: {
      type: Number,
      default: -1,
    },
    originalQuery: {
      type: String,
      default: '',
    },
    query: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formattedOptions: [],
    };
  },
  computed: {
    searchTitle() {
      return this.originalQuery && this.originalQuery.length ? 'Suggested Searches' : 'Top Searches';
    },
  },
  watch: {
    options() {
      this.formatOptions();
    },
    originalQuery() {
      this.formatOptions();
    },
  },
  mounted() {
    this.formatOptions();
  },
  methods: {
    // Parse options so we don't have to use v-html to style highlight
    formatOptions() {
      const { query, options } = this;
      const length = query && query.length;

      if (!length) {
        this.formattedOptions = options.map((deal) => {
          const option = deal.public_name;
          return {
            slug: deal.slug,
            value: option,
            prefix: option,
            highlight: '',
            suffix: '',
          };
        });

        return;
      }

      this.formattedOptions = options.map((deal) => {
        const option = deal.public_name;
        const startIndex = option.toLowerCase().indexOf(query.toLowerCase());

        if (startIndex < 0) {
          return {
            slug: deal.slug,
            value: option,
            prefix: option,
            highlight: '',
            suffix: '',
          };
        }

        const endIndex = startIndex + length;
        const highlight = option.substring(startIndex, endIndex);

        const prefix = startIndex ? option.substring(0, startIndex) : '';
        const suffix = (length !== option.length) ? option.substring(endIndex, option.length) : '';

        return {
          slug: deal.slug,
          value: option,
          prefix,
          highlight,
          suffix,
        };
      });
    },
  },
};
